import type { Id } from "@Aspecto/backend/convex/_generated/dataModel";

import { createFileRoute } from "@tanstack/react-router";

import { AppPageContent } from "@/components/layout/app-page";
import { NewsletterView } from "@/components/newsletters";

export const Route = createFileRoute("/_authenticated/app/newsletters/$newsletterId")({
  component: NewsletterPage,
});

function NewsletterPage() {
  const { newsletterId } = Route.useParams();

  return (
    <AppPageContent>
      <NewsletterView newsletterId={newsletterId as Id<"newsletters">} />
    </AppPageContent>
  );
}
